import { Item } from '@radix-ui/react-navigation-menu'
import React from 'react'

import { cn } from '~/styled'

/*
 * (!)
 * NavigationMenu vertical behaviour was buggy so had to build the
 * opening/closing nested Content(Accordion) based on `Collapsible` instead.
 * This means that the `value` prop does nothing, so removing it from typescript
 */
type TNavigationMenuVerticalItemProps = Omit<
  React.ComponentProps<typeof Item>,
  'value'
>

export const NavigationMenuVerticalItem = (
  props: TNavigationMenuVerticalItemProps
): React.JSX.Element => (
  <Item
    className={cn(
      '[ul_li_&]:[--navigation-menu-vertical-item-pl:--spacing(8)]',
      '[ul_li_&_&]:[--navigation-menu-vertical-item-pl:--spacing(12)]',
      '[ul_li_&_&_&]:[--navigation-menu-vertical-item-pl:--spacing(16)]'
    )}
    {...props}
  />
)
